import React from "react";
import Helmet from "react-helmet";
import { withRouter } from "react-router";
import { Card } from "antd";

const Analytics = props => {
  let helmet;
  switch (props.location.pathname) {
    // case-level analytics
    case "/ptab/analytics/case-level/by-status-and-phase":
      helmet = {
        title: "Status & Phase | Case-level PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content: "PTAB,AIA Trials,Analytics,Case Analytics,Cases by Status,Cases by Phase,Outcomes at Institution Decision,Outcomes at Final Written Decision"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get stats and charts for PTAB cases by status and phase."
          }
        ]
      };
      break;
    case "/ptab/analytics/case-level/by-sector-and-entity-type":
      helmet = {
        title: "Sector & Entity Type | Case-level PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content: "PTAB,AIA Trials,Analytics,Case Analytics,Cases by Tech Center,Cases by Industry,Cases by Petitioner Entity Type,Cases by Patent Owner Entity Type"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get stats and charts for PTAB cases by technology centers, industries and entity types."
          }
        ]
      };
      break;
    case "/ptab/analytics/case-level/by-date":
      helmet = {
        title: "Activities | Case-level PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content: "PTAB,AIA Trials,Analytics,Case Analytics,Cases by Date,Filed v.s. Terminated"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get stats and charts for PTAB cases by date."
          }
        ]
      };
      break;
    case "/ptab/analytics/case-level/top-parties":
      helmet = {
        title: "Top Parties | Case-level PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content: "PTAB,AIA Trials,Analytics,Case Analytics,Top 20 Petitioners,Top 20 Patent Owners"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get top 20 petitioners and patent owners at the PTAB."
          }
        ]
      };
      break;
    case "/ptab/analytics/case-level/isix":
      helmet = {
        title: "ISIX | Case-level PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content: "PTAB,AIA Trials,Analytics,Case Analytics,ISIX,Law Firm Analytics,Top Successful Law Firms,Institutional Success IndeX,Petitioner Law Firm,Patent Owner Law Firm"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get top successful law firms at the PTAB."
          }
        ]
      };
      break;
    case "/ptab/analytics/case-level/by-counsel":
      helmet = {
        title: "Counsel | Case-level PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content:
              "PTAB,AIA Trials,Analytics,Case Analytics,Final Written Decision Rates for Petitioners' Counsel,Institution Rates for Petitioners' Counsel,Final Written Decision Rates for Patent Owners' Counsel,Institution Rates for Patent Owners' Counsel"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get stats and charts for PTAB cases by counsel."
          }
        ]
      };
      break;
    case "/ptab/analytics/case-level/by-judge":
      helmet = {
        title: "Judges | Case-level PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content:
              "PTAB,AIA Trials,Analytics,Case Analytics,Institution Rates for Author Judge,Final Written Decision Rates for Author Judge,Institution Rates for Panel Judge,Final Written Decision Rates for Panel Judge"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get stats and charts for PTAB cases by judge."
          }
        ]
      };
      break;
    // claim-level analytics
    case "/ptab/analytics/claim-level/by-outcome":
      helmet = {
        title: "Outcomes | Claim-level PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content:
              "PTAB,AIA Trials,Analytics,Claim Analytics,Institutions for Challenged Claims,Institutions for Challenged Claims,Outcomes for Instituted Claims,Outcomes for Instituted Claims,102,103,102 & 103"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get stats and charts for challenged claims by outcomes."
          }
        ]
      };
      break;
    case "/ptab/analytics/claim-level/by-counsel":
      helmet = {
        title: "Counsel | Claim-level PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content:
              "PTAB,AIA Trials,Analytics,Claim Analytics,Final Written Decision Rates for Petitioners' Counsel,Institution Rates for Petitioners' Counsel,Final Written Decision Rates for Patent Owners' Counsel,Institution Rates for Patent Owners' Counsel"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get stats and charts for challenged claims by counsel."
          }
        ]
      };
      break;
    case "/ptab/analytics/claim-level/by-judge":
      helmet = {
        title: "Judges | Claim-level PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content:
              "PTAB,AIA Trials,Analytics,Claim Analytics,Institution Rates for Author Judge,Final Written Decision Rates for Author Judge,Institution Rates for Panel Judge,Final Written Decision Rates for Panel Judge"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get stats and charts for challenged claims by judge."
          }
        ]
      };
      break;
    default:
      helmet = {
        title: "PTAB Analytics",
        meta: [
          {
            name: "keywords",
            content: "PTAB,AIA Trials,Analytics,Claim Analytics,Cases,Claims"
          },
          {
            name: "description",
            content: "PTAB Analytics. Get latest analytics for case status, claim outcome, judges and lawfirms."
          }
        ]
      };
  }
  return (
    <div>
      <Helmet {...helmet} />
      <Card bodyStyle={{ padding: 0 }}>
        {props.children}
      </Card>
    </div>
  );
};

export default withRouter(Analytics);
